import { BellElectric, LayoutGrid, LayoutPanelLeft, ListFilter } from "lucide-react";

const CoursePageHighlightsPrerequisiteAudience=({coursePageObject})=>{
return(<>
 <div className="themeCoursePage"  style={{marginTop:"50px",marginBottom:"30px",paddingBottom:"25px",overflow:"hidden",
  minHeight:"190px",borderRadius:"25px",position:"relative",
  background:`${coursePageObject?.targetAudience?.bgColor?.color}`,
    border:` ${coursePageObject?.targetAudience?.border?.borderWidth?.value+coursePageObject?.targetAudience?.border?.borderWidth?.resolution} ${coursePageObject?.targetAudience?.border?.borderType}  ${coursePageObject?.targetAudience?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.targetAudience?.borderRadius?.topLeft?.value}${coursePageObject?.targetAudience?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.targetAudience?.borderRadius?.topRight?.value}${coursePageObject?.targetAudience?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.targetAudience?.borderRadius?.bottomLeft?.value}${coursePageObject?.targetAudience?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.targetAudience?.borderRadius?.bottomRight?.value}${coursePageObject?.targetAudience?.borderRadius?.bottomRight?.resolution}`,
}}>
<div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
  borderBottomLeftRadius:"50px",}}>

</div>

<div className=" gridForCoursePageFiftyFifty"  style={{marginTop:"20px",overflow:"hidden",
    minHeight:"190px",position:"relative"}}>

<div className=" " style={{marginBottom:"20px"}}>
<div className="themeCoursePage courseContentTitleFontCoursePage coursePageTitleFont"
style={{color:coursePageObject?.targetAudience?.textColor?.color}}>Target Audience</div>
      <div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon">
      <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color={coursePageObject?.targetAudience?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.targetAudience?.subTextColor?.color}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div>
</div>

<div className="" style={{ background:`${coursePageObject?.prerequisite?.bgColor?.color}`,
    border:` ${coursePageObject?.prerequisite?.border?.borderWidth?.value+coursePageObject?.prerequisite?.border?.borderWidth?.resolution} ${coursePageObject?.prerequisite?.border?.borderType}  ${coursePageObject?.prerequisite?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.prerequisite?.borderRadius?.topLeft?.value}${coursePageObject?.prerequisite?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.prerequisite?.borderRadius?.topRight?.value}${coursePageObject?.prerequisite?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.prerequisite?.borderRadius?.bottomLeft?.value}${coursePageObject?.prerequisite?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.prerequisite?.borderRadius?.bottomRight?.value}${coursePageObject?.prerequisite?.borderRadius?.bottomRight?.resolution}`,
position:"relative",marginBottom:"10px"}} >
   
<div className="themeCoursePage courseContentTitleFontCoursePage coursePageTitleFont" style={{color:coursePageObject?.prerequisite?.textColor?.color}}>Prerequisite</div>
 
    
  
  <div className=" " style={{
    padding:"10px",marginTop:"5px"}}>
    
    <div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.prerequisite?.iconColor?.color}/> 
        <div className="themeCoursePage coursePageSubTitleFont "
   style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.prerequisite?.subTextColor?.color}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div><div   className="courseWhatWillearnIcon ">
        <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.prerequisite?.iconColor?.color}/> 
        <div className="themeCoursePage coursePageSubTitleFont "
   style={{fontSize:"14px",fontWeight:"500",color:coursePageObject?.prerequisite?.subTextColor?.color}}> 
     This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
   
        </div>
        </div>
  </div>
  
  
  
    
    </div>

  
    </div> 
    <div className=""  style={{marginTop:"40px",paddingTop:"40px",paddingBottom:"40px",background:`${coursePageObject?.highlights?.bgColor?.color}`,
    border:` ${coursePageObject?.highlights?.border?.borderWidth?.value+coursePageObject?.highlights?.border?.borderWidth?.resolution} ${coursePageObject?.highlights?.border?.borderType}  ${coursePageObject?.highlights?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.highlights?.borderRadius?.topLeft?.value}${coursePageObject?.highlights?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.highlights?.borderRadius?.topRight?.value}${coursePageObject?.highlights?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.highlights?.borderRadius?.bottomLeft?.value}${coursePageObject?.highlights?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.highlights?.borderRadius?.bottomRight?.value}${coursePageObject?.highlights?.borderRadius?.bottomRight?.resolution}`,
position:"relative"}}>
 <div className="themeCoursePage   coursePageTitleFont"  style={{ fontSize:"28px",display:"flex",justifyContent:"left",gap:"10px",
  fontWeight:"700",margin:"3px",color:coursePageObject?.highlights?.textColor?.color}}>
  
  <BellElectric  strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color={coursePageObject?.highlights?.icon2Color?.color} />
  
  Highlights
  </div>
  

<div className="themeCoursePage courseWhatWillearnTextCoursePage" style={{
  marginTop:"5px"}}>
  
      <div   className="courseWhatWillearnIcon "style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests To Equip You With All Inportant Trends In Blender
 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div><div  className="courseWhatWillearnIcon"style={{background:coursePageObject?.highlights?.iconBgColor?.color,margin:"10px",marginTop:"20px",padding:"10px",borderRadius:"15px"}}>
      <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.highlights?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"14px",color:coursePageObject?.highlights?.subTextColor?.color,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
</div>



  
  </div>
    </div>
</>)
} 
export default CoursePageHighlightsPrerequisiteAudience;